import { NavButtonType } from '@/util/data/navButtons';
import Link from 'next/link';
import type { Route } from 'next';
import { FaLongArrowAltRight } from 'react-icons/fa';
import { useGlobalContext } from '../../app/tools/globalContext';

export default function Navlink({ button }: { button: NavButtonType }) {
  const { mobileMenuOpen, setMobileMenuOpen } = useGlobalContext();

  return (
    <div className='group/item hover:text-white'>
      <Link
        href={button.to as Route}
        className='flex w-full items-center justify-start whitespace-nowrap py-1'
        onClick={() => setMobileMenuOpen(false)}
      >
        <div className='flex items-center justify-center group-hover/navbar:justify-start'>
          <div className='px-2 text-[1.2em] group-hover/item:animate-shake-rotate'>
            {button.icon}
          </div>
          <p
            className={`
             opacity-0 transition-opacity
            group-hover/navbar:opacity-100
            ${mobileMenuOpen ? '!block !opacity-100' : ''}
          `}
          >
            {button.label}
          </p>
        </div>
      </Link>
      {button.subnav && (
        <div className='transition-[max-height, opacity] flex max-h-0 flex-col overflow-clip pl-3 opacity-0 delay-300 duration-1000 group-hover/item:max-h-[999px] group-hover/item:opacity-100 group-hover/item:delay-500 space-y-1'>
          {button.subnav.map((subnav, i) => (
            <Link
              key={subnav.label + i}
              href={subnav.to as Route}
              className='flex w-full items-center justify-start whitespace-nowrap py-1 text-gray-400 hover:text-white'
              onClick={() => setMobileMenuOpen(false)}
            >
              <div className='px-2 text-[1em]'>
                <FaLongArrowAltRight />
              </div>
              <p className='text-xs'>{subnav.label}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
